document.addEventListener("DOMContentLoaded", function () {
  const currentUrl = new URL(window.location.href);
  const isVariantSpecifiedInUrl = currentUrl.searchParams.has("variant");
  const variantsDD = document.querySelector(".variantsDD");
  const atcButton = document.querySelector("#unique_atc");
  const options = document.querySelectorAll(
    ".c-pp-anniversary__card .c-pp-anniversary__option"
  );
  const card = document.querySelector(".c-pp-anniversary__card");
  const optionValues = Array.from(options).map(
    (option) => option.dataset.design
  );
  const errorText = document.querySelector(".c-pp-anniversary__error-text");
  const applyButton = document.querySelector(".c-pp-anniversary__button");
  const visibleAfterSelectionContainer = document.querySelector(
    ".visible_after_selection"
  );
  const selectAnotherVehicleButton = document.querySelector("#another_btn");
  const selectionDisplay = document.querySelector(
    ".c-pp-anniversary__selection-display"
  );
  const selectionResetButton = document.querySelector(
    ".c-pp-anniversary__selection-display-reset"
  );

  const anniversary_option = Array.from(options).find(
    (option) => option.dataset.design && option.dataset.design.includes("250")
  );
  const anniversaryInfo = anniversary_option.querySelector(
    ".c-pp-anniversary__option .c-pp-anniversary__info"
  );
  const anniversaryImgContainer = anniversary_option.querySelector(
    ".c-pp-anniversary__option .c-pp-anniversary__image-container"
  );

  const bottomButton = document.querySelector("#xdBannerDropdownOpenId");
  const bottomAtcButton = document.querySelector(
    ".fixed-banner-btn .atcBtnDrawer"
  );

  const isMobile = window.innerWidth < 768;

  if (!variantsDD) {
    return;
  }

  /* ============================================================
   * FIREWORKS ENGINE — optimized
   * - Flag image preloaded & decoded ONCE at page load (fixes the
   *   first-click jank on mobile caused by network fetch + decode)
   * - Particles drawn from pre-rendered glow sprites via drawImage
   *   instead of arc()+fill()+shadowBlur (5-10x faster per frame)
   * - Transparent trail fade via destination-out (no more black
   *   box over the card) + additive "lighter" blending for glow
   * - All physics are delta-time based (consistent speed on any
   *   device / refresh rate, incl. 120Hz phones)
   * - Particle object pooling (zero GC churn during animation)
   * - devicePixelRatio capped at 2
   * ============================================================ */
  const Fireworks = (function () {
    const FLAG_SRC =
      "https://cdn.shopify.com/s/files/1/0050/1068/6042/files/star.svg?v=1676480837";
    // Old Glory palette — red / white / blue (white weighted twice for sparkle)
    const COLORS = ["#b31942", "#ffffff", "#0a3161", "#ffffff", "#ff2e3f", "#3c6fe0"];
    const GRAVITY = 160; // px / s^2
    const DRAG = 0.985; // velocity retention per frame @60fps
    const ROCKET_SPEED = 480; // px / s
    const LIFE_AFTER_BURST = isMobile ? 2.2 : 1.9; // seconds
    const PARTICLE_COUNT = isMobile ? 220 : 520;
    const DPR = Math.min(window.devicePixelRatio || 1, 2);
    const REDUCED_MOTION = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    // --- Preload + decode the flag image once, at page load ---
    const flagImage = new Image();
    flagImage.decoding = "async";
    flagImage.src = FLAG_SRC;
    let flagReady = false;
    if (flagImage.decode) {
      flagImage.decode().then(
        () => (flagReady = true),
        () => {}
      );
    } else {
      flagImage.onload = () => (flagReady = true);
    }

    // --- Pre-rendered glow sprites (the big perf win) ---
    const SPRITE_SIZE = 24;
    const sprites = COLORS.map((color) => {
      const c = document.createElement("canvas");
      c.width = c.height = SPRITE_SIZE;
      const x = c.getContext("2d");
      const r = SPRITE_SIZE / 2;
      const g = x.createRadialGradient(r, r, 0, r, r, r);
      g.addColorStop(0, "rgba(255,255,255,1)");
      g.addColorStop(0.25, color);
      g.addColorStop(1, "rgba(0,0,0,0)");
      x.fillStyle = g;
      x.fillRect(0, 0, SPRITE_SIZE, SPRITE_SIZE);
      return c;
    });
    const trailSprite = sprites[1]; // silver-white sparks for the rocket trail

    // --- Particle pool ---
    const pool = [];
    function obtain() {
      return pool.pop() || {};
    }
    function release(p) {
      pool.push(p);
    }

    // --- Runtime state ---
    let canvas = null;
    let ctx = null;
    let frameId = null;
    let removeTimeout = null;
    let particles = [];
    let W = 0;
    let H = 0;
    let last = 0;
    let phase = "idle"; // idle | rocket | burst
    let rocketY = 0;
    let rocketX = 0;
    let burstAge = 0;
    let flagScale = 0;

    function easeOutBack(t) {
      const c1 = 1.70158;
      const c3 = c1 + 1;
      return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
    }

    function spawnParticle(x, y, opts) {
      const p = obtain();
      const angle = opts.angle;
      const speed = opts.speed;
      p.x = x;
      p.y = y;
      p.vx = Math.cos(angle) * speed;
      p.vy = Math.sin(angle) * speed;
      p.maxLife = opts.life;
      p.life = opts.life;
      p.size = opts.size;
      p.sprite = opts.sprite;
      p.twinkle = opts.twinkle || false;
      p.twinklePhase = Math.random() * Math.PI * 2;
      particles.push(p);
    }

    function explode(x, y) {
      // Main shell — full circle, biased upward
      for (let i = 0; i < PARTICLE_COUNT; i++) {
        const angle = Math.random() * Math.PI * 2;
        // ring + filled core gives a fuller, rounder burst
        const speed =
          (Math.random() < 0.7
            ? 90 + Math.random() * 130
            : 30 + Math.random() * 60) * (isMobile ? 0.8 : 1);
        spawnParticle(x, y, {
          angle: angle,
          speed: speed,
          life: 1.1 + Math.random() * 0.9,
          size: 4 + Math.random() * 5,
          sprite: sprites[i % sprites.length],
          twinkle: i % 5 === 0,
        });
      }
      // A small white "flash core" of slow bright particles
      const coreCount = isMobile ? 14 : 26;
      for (let i = 0; i < coreCount; i++) {
        spawnParticle(x, y, {
          angle: Math.random() * Math.PI * 2,
          speed: 10 + Math.random() * 30,
          life: 0.35 + Math.random() * 0.25,
          size: 8 + Math.random() * 8,
          sprite: sprites[1],
        });
      }
    }

    function spawnTrail(dt) {
      // ~90 sparks/sec behind the rocket, scaled by dt
      let n = Math.max(1, Math.round(90 * dt));
      if (isMobile) n = Math.max(1, Math.round(n * 0.6));
      for (let i = 0; i < n; i++) {
        spawnParticle(
          rocketX + (Math.random() - 0.5) * 3,
          rocketY + Math.random() * 14,
          {
            angle: Math.PI / 2 + (Math.random() - 0.5) * 0.6, // downward-ish
            speed: 20 + Math.random() * 40,
            life: 0.25 + Math.random() * 0.3,
            size: 2.5 + Math.random() * 2.5,
            sprite: trailSprite,
          }
        );
      }
    }

    function frame(ts) {
      if (!ctx) return;
      let dt = (ts - last) / 1000;
      last = ts;
      // Clamp dt so a tab-switch or slow first frame can't cause a jump
      if (dt > 0.05) dt = 0.05;
      if (dt <= 0) {
        frameId = requestAnimationFrame(frame);
        return;
      }

      // Fade previous frame while KEEPING transparency
      ctx.globalCompositeOperation = "destination-out";
      ctx.fillStyle = "rgba(0,0,0,0.28)";
      ctx.fillRect(0, 0, W, H);

      // Additive blending = glow without shadowBlur
      ctx.globalCompositeOperation = "lighter";

      if (phase === "rocket") {
        rocketY -= ROCKET_SPEED * dt;
        spawnTrail(dt);

        // Rocket head: one bright sprite, no gradients per frame
        ctx.globalAlpha = 1;
        ctx.drawImage(sprites[1], rocketX - 6, rocketY - 6, 12, 12);

        if (rocketY <= H * 0.35) {
          phase = "burst";
          burstAge = 0;
          flagScale = 0;
          explode(rocketX, rocketY);
        }
      } else if (phase === "burst") {
        burstAge += dt;
      }

      // Update + draw particles (single pass, in-place compaction)
      const dragNow = Math.pow(DRAG, dt * 60);
      let write = 0;
      for (let read = 0; read < particles.length; read++) {
        const p = particles[read];
        p.life -= dt;
        if (p.life <= 0) {
          release(p);
          continue;
        }
        p.vy += GRAVITY * dt;
        p.vx *= dragNow;
        p.vy *= dragNow;
        p.x += p.vx * dt;
        p.y += p.vy * dt;

        let alpha = p.life / p.maxLife;
        if (p.twinkle) {
          alpha *= 0.55 + 0.45 * Math.sin(p.life * 25 + p.twinklePhase);
        }
        if (alpha > 0.01) {
          const s = p.size;
          ctx.globalAlpha = alpha;
          ctx.drawImage(p.sprite, p.x - s, p.y - s, s * 2, s * 2);
        }
        particles[write++] = p;
      }
      particles.length = write;
      ctx.globalAlpha = 1;

      // Star/flag reveal at the burst point (drawn solid, not additive)
      if (phase === "burst" && flagReady) {
        if (flagScale < 1) {
          flagScale = Math.min(1, flagScale + dt * 1.8);
        }
        const eased = easeOutBack(flagScale);
        const imgSize = (isMobile ? 90 : 120) * eased;
        const fade = Math.min(
          1,
          Math.max(0, (LIFE_AFTER_BURST - burstAge) / 0.5)
        );
        ctx.globalCompositeOperation = "source-over";
        ctx.globalAlpha = fade;
        ctx.drawImage(
          flagImage,
          rocketX - imgSize / 2,
          rocketY - imgSize / 2,
          imgSize,
          imgSize
        );
        ctx.globalAlpha = 1;
      }

      // End condition: burst played out AND particles gone (or hard cap)
      if (
        phase === "burst" &&
        (burstAge >= LIFE_AFTER_BURST || particles.length === 0)
      ) {
        fadeOutAndRemove();
        return;
      }

      frameId = requestAnimationFrame(frame);
    }

    function fadeOutAndRemove() {
      if (frameId) {
        cancelAnimationFrame(frameId);
        frameId = null;
      }
      if (canvas) {
        const c = canvas;
        c.style.transition = "opacity 0.3s ease";
        c.style.opacity = "0";
        removeTimeout = setTimeout(() => {
          c.remove();
        }, 320);
      }
      cleanupState();
    }

    function cleanupState() {
      for (let i = 0; i < particles.length; i++) release(particles[i]);
      particles.length = 0;
      canvas = null;
      ctx = null;
      phase = "idle";
    }

    function stop() {
      if (frameId) {
        cancelAnimationFrame(frameId);
        frameId = null;
      }
      if (removeTimeout) {
        clearTimeout(removeTimeout);
        removeTimeout = null;
      }
      if (canvas) {
        canvas.remove();
      }
      cleanupState();
    }

    function trigger(targetElement) {
      stop();
      if (REDUCED_MOTION) return; // respect user preference
      if (document.hidden) return;

      const w = targetElement.offsetWidth;
      const h = targetElement.offsetHeight;
      if (!w || !h) return;

      canvas = document.createElement("canvas");
      canvas.className = "firework-canvas";
      canvas.width = Math.round(w * DPR);
      canvas.height = Math.round(h * DPR);
      canvas.style.cssText =
        "position:absolute;top:0;left:0;width:100%;height:100%;" +
        "pointer-events:none;z-index:100;";

      targetElement.style.position = "relative";
      targetElement.appendChild(canvas);

      ctx = canvas.getContext("2d");
      ctx.scale(DPR, DPR);

      W = w;
      H = h;
      rocketX = w / 2;
      rocketY = h + 10;
      phase = "rocket";
      last = performance.now();
      frameId = requestAnimationFrame(frame);
    }

    return { trigger: trigger, stop: stop };
  })();

  function triggerFireworks(targetElement) {
    Fireworks.trigger(targetElement);
  }
  function stopFireworks() {
    Fireworks.stop();
  }
  /* ===================== /FIREWORKS ENGINE ===================== */

  function scrollToVariantsDD(val) {
    if (isMobile) {
      const yOffset = -val;
      const y =
        variantsDD.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({
        top: y,
        behavior: "smooth",
      });
    }
  }

  variantsDD.addEventListener("click", function (e) {
    const target = e.target;
    const closestVariantButton = target.closest(".c-btn-add-to-cart");
    if (
      target.classList.contains("c-btn-add-to-cart") ||
      closestVariantButton
    ) {
      showCard();
    }
  });

  if (isVariantSpecifiedInUrl) {
    showCard();
  }

  function showVisibleAfterSelection() {
    visibleAfterSelectionContainer.classList.add("visible");
  }
  function hideVisibleAfterSelection() {
    visibleAfterSelectionContainer.classList.remove("visible");
  }
  function showCard() {
    card.style.display = "block";
    scrollToVariantsDD(30);
    bottomButton.style.display = "block";
    bottomButton.innerHTML = "SELECT YOUR DESIGN";
    bottomAtcButton.style.display = "none";
  }
  function hideCard() {
    card.style.display = "none";
    bottomAtcButton.style.display = "none";
  }
  function showSelectionDisplay() {
    selectionDisplay.classList.remove("hidden");
  }
  function hideSelectionDisplay() {
    selectionDisplay.classList.add("hidden");
  }

  selectionResetButton.addEventListener("click", function () {
    const selectedOption = document.querySelector(
      ".c-pp-anniversary__option--selected"
    );
    if (selectedOption) {
      selectedOption.classList.remove("c-pp-anniversary__option--selected");
    }
    hideSelectionDisplay();
    showCard();
    errorText.classList.add("hidden");
    selectionDisplay
      .querySelectorAll(".c-pp-anniversary__option")
      .forEach((item) => {
        item.classList.add("hidden");
      });
    hideVisibleAfterSelection();
    bottomButton.classList.remove("handleApply");
  });

  selectAnotherVehicleButton.addEventListener("click", function () {
    hideCard();
    hideVisibleAfterSelection();
    hideSelectionDisplay();
    const selectedOption = document.querySelector(
      ".c-pp-anniversary__option--selected"
    );
    if (selectedOption) {
      selectedOption.classList.remove("c-pp-anniversary__option--selected");
    }
    errorText.classList.add("hidden");
    selectionDisplay
      .querySelectorAll(".c-pp-anniversary__option")
      .forEach((item) => {
        item.classList.add("hidden");
      });
    bottomButton.classList.remove("handleApply");
  });

  function showErrorText() {
    const selectedOption = document.querySelector(
      ".c-pp-anniversary__option--selected"
    );
    if (!selectedOption) {
      errorText.classList.remove("hidden");
    }
  }

  applyButton.addEventListener("click", function () {
    stopFireworks();
    const selectedOption = document.querySelector(
      ".c-pp-anniversary__option--selected"
    );
    const selectedOptionValue = selectedOption
      ? selectedOption.dataset.design
      : null;
    const selectedOptionDisplayItem = selectionDisplay.querySelector(
      `[data-design='${selectedOptionValue}']`
    );

    if (!selectedOption) {
      showErrorText();
      return;
    }

    showSelectionDisplay();
    selectedOptionDisplayItem.classList.remove("hidden");
    updateATCButtonDataset();
    hideCard();
    showVisibleAfterSelection();
    scrollToVariantsDD(100);
    applyButton.classList.remove("cta-glow-ping");
  });

  function updateATCButtonDataset() {
    const selectedOption = document.querySelector(
      ".c-pp-anniversary__option--selected"
    );
    if (!selectedOption) throw new Error("No option selected");
    const selectedOptionValue = selectedOption.dataset.design;
    const selection = atcButton.dataset.selection;
    let updatedSelection = selection;
    optionValues.forEach((val) => {
      if (updatedSelection.includes(val)) {
        updatedSelection = updatedSelection.replace(" - " + val, "");
      }
    });
    const newSelection = `${updatedSelection} - ${selectedOptionValue}`;
    atcButton.dataset.selection = newSelection;
  }

  options.forEach((option) => {
    option.addEventListener("click", handleOptionClick);
  });

  function handleOptionClick(e) {
    const activeOption = document.querySelector(
      ".c-pp-anniversary__option--selected"
    );
    if (activeOption) {
      activeOption.classList.remove("c-pp-anniversary__option--selected");
    }
    e.currentTarget.classList.add("c-pp-anniversary__option--selected");

    if (e.currentTarget.dataset.design.includes("250")) {
      triggerFireworks(e.currentTarget);
    } else {
      stopFireworks();
    }

    errorText.classList.add("hidden");
    atcButton.disabled = false;
    atcButton.style.display = "flex";
    applyButton.classList.add("cta-glow-ping");

    bottomButton.innerHTML = "BUY NOW";
    bottomButton.classList.add("handleApply");
    anniversaryImgContainer.scrollIntoView({ behavior: "smooth", block: "center" });

  }

  if (bottomButton) {
    bottomButton.addEventListener("click", () => {
      const hasHandleApply = bottomButton.classList.contains("handleApply");
      if (hasHandleApply) {
        applyButton.click();
        atcButton.click();
      }
    });
  }
});